/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-05-15",
    versionChannel: "nightly",
    buildDate: "2023-05-15T00:19:10.557Z",
    commitHash: "d0f8061c852e34a0c5d5b16d721c11da492ef5b2",
};
